import type { TrainingLessonSpecific } from './trainingLessonUi';

export const priest1DutiesEs: TrainingLessonSpecific = {
  intro:
    'El Presbítero tiene responsabilidades especiales: bendecir y pasar la Santa Cena, bautizar (según delegación) y servir con dignidad. La ordenanza no es mecánica; la preparación previa cambia la experiencia del que recibe.',
  objectives: [
    'Entender responsabilidades del Presbítero.',
    'Prepararse dignamente para bendecir/pasar la Santa Cena.',
    'Diferenciar función del Presbítero vs otros oficios.',
    'Aprender preparación espiritual antes de oficiar.',
    'Establecer hábitos de reverencia al oficiar.',
  ],
  briefHeading: 'El Presbítero en breve',
  briefBody:
    'El presbítero administra la Santa Cena, puede bautizar cuando se le delega, y oficia con reverencia. Su ejemplo y preparación ayudan a los miembros a sentir el Espíritu en cada ordenanza.',
  scriptures: [
    { ref: 'DyC 20:46–52', text: 'Deberes del Presbítero: predicar, enseñar, bautizar, administrar la Santa Cena.' },
    { ref: 'DyC 13', text: 'Las llaves del ministerio de ángeles, del arrepentimiento y del bautismo.' },
    { ref: '3 Nefi 18:1–7', text: 'La Santa Cena: recordar al Salvador.' },
    { ref: 'DyC 84:33–39', text: 'Los que son ordenados son santificados por el Espíritu.' },
    { ref: 'Hebreos 5:4', text: 'Nadie toma para sí esta honra, sino el que es llamado.' },
  ],
  didYouKnow: [
    'La ordenanza no es "mecánica"; la dignidad importa.',
    'Preparación previa cambia la experiencia del que recibe.',
  ],
  practiceItems: [
    'Orar antes de la reunión para prepararse espiritualmente',
    'Repasar las oraciones sacramentales (DyC 20:77, 79)',
    'Llegar temprano para coordinar con quien preside',
    'Revisar postura y tono de voz al oficiar',
    'Coordinar con el que preside la reunión sacramental',
    'Breve autoevaluación post-reunión: ¿qué mejoraré?',
  ],
  reflectionQuestions: [
    '¿Qué hábito debo corregir para oficiar con más dignidad?',
    '¿Cómo me preparo mejor antes de bendecir o pasar la Santa Cena?',
    '¿Qué siento cuando sirvo en esta ordenanza?',
  ],
  actionText: 'Preparar la Santa Cena como si fuera para Cristo.',
};
